import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import { LoadingIndicator } from 'common/components/preloader';
import InviteButton from 'project/containers/invite_collaborator_button';
import CollaboratorRow from 'project/containers/collaborator_row';
import RemoveModal from 'project/containers/remove_collaborator';
import CollaboratorHistory from 'project/containers/collaborator_history';
import { UNLIMITED_COLLABORATION } from 'pap/constants';

const EmptyCollaborators = ({ projectId, onAdmin }) => (
  <div className="collaborators-container small-16 columns">
    <h3 className="section-header">Collaborators</h3>
    <div className="empty-state no-results">
      <div className="empty-state-content">
        <h3>{ onAdmin? "No invited collaborators" : "You haven't invited any collaborators" }</h3>
        <div className="empty-state-cta">
          <InviteButton projectId={projectId} />
        </div>
      </div>
    </div>
  </div>
);

const UpgradeCTA = ({onClick, price}) => (
  <div className="collaborators-container small-16 columns">
    <h3 className="section-header">Collaborators</h3>
    <div className="empty-state upgrade">
      <div className="empty-state-content">
        <h3>Work on your project with friends or co-workers for just ${price}</h3>
        <button className="btn btn-primary" onClick={onClick}>
          Upgrade
        </button>
      </div>
    </div>
  </div>
)

const Collaborators = ({
  isLoading, collaborators, projectId, project, toggleFeaturesModal, onAdmin
}) => {
  if (isLoading) {
    return (<LoadingIndicator />);
  }

  if (!project.collaboration_allowed && !onAdmin) {
    const collabFeature = project.features.find(
      ({feature}) => feature.name == UNLIMITED_COLLABORATION
    );

    /* legacy projects or projects that don't have an optional collaboration feature
       can't be upgraded */
    if (project.is_legacy || !collabFeature) {
      return null;
    }

    const collabFeaturePrice = collabFeature.feature.price;

    return <UpgradeCTA onClick={toggleFeaturesModal} price={collabFeaturePrice}/>
  }

  if (!collaborators || !collaborators.length) {
    return (<EmptyCollaborators projectId={projectId} onAdmin={onAdmin} />);
  }

  return (
    <div className="collaborators-container small-16 columns">
      <h3 className="section-header">Collaborators</h3>
      <table className="table collaborators-table table-default">
        <thead>
          <tr><td>user</td><td>invitation</td><td /></tr>
        </thead>
        {collaborators.map(collaborator => (
          <CollaboratorRow key={v4()} collaborator={collaborator} projectId={projectId} />
        ))}
      </table>
      <InviteButton projectId={projectId} />
      <RemoveModal projectId={projectId} />
      <CollaboratorHistory projectId={projectId} />
   </div>
  );
};

EmptyCollaborators.propTypes = {
  projectId: PropTypes.number.isRequired,
  onAdmin: PropTypes.bool,
};

Collaborators.propTypes = {
  projectId: PropTypes.number.isRequired,
  project: PropTypes.object.isRequired,
  toggleFeaturesModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  collaborators: PropTypes.array,
  onAdmin: PropTypes.bool
};

export default Collaborators;



// WEBPACK FOOTER //
// ./project/components/collaborators.jsx